import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import z from "zod";

const searchParamsSchema = z.object({
	referral_code: z.string().optional(),
});

export const Route = createFileRoute("/auth/signup")({
	validateSearch: zodValidator(searchParamsSchema),
	beforeLoad({ search }) {
		throw redirect({
			to: "/",
			search: { auth: "signup", referral_code: search.referral_code },
			replace: true,
		});
	},
});
